/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("TopMenuWidget", ["WidgetGroupBase", "WidgetFactory"], function (context, cls) {
  /**
   * TopMenu widget.
   * @class TopMenuWidget
   * @memberOf classes
   * @extends classes.WidgetGroupBase
   * @publicdoc Widgets
   */
  cls.TopMenuWidget = context.oo.Class(cls.WidgetGroupBase, function ($super) {
    return /** @lends classes.TopMenuWidget.prototype */ {
      __name: "TopMenuWidget",

      /** @type {Boolean} */
      _globalTopmenu: false,

      /**
       * @inheritDoc
       */
      constructor: function (opts) {
        $super.constructor.call(this, opts);
      },

      /**
       * @inheritDoc
       */
      _initElement: function () {
        this._ignoreLayout = true;
        $super._initElement.call(this);
      },

      /**
       * Define this topMenu as global one
       * @param {Boolean} isGlobal - true to set as global TM
       */
      setGlobal: function (isGlobal) {
        this._globalTopmenu = isGlobal;
      },

      /**
       * Check if TM is set as Global
       * @return {Boolean} true if global, false otherwise
       */
      isGlobal: function () {
        return this._globalTopmenu;
      },

      /**
       * Priority of this menu
       * @param {number} order the priority of this menu
       * @publicdoc
       */
      setOrder: function (order) {
        this.setStyle({
          order: order
        });
      },

      /**
       * Get priority of this menu
       * @returns {number} priority of this menu
       * @publicdoc
       */
      getOrder: function () {
        return this.getStyle("order");
      },

      setHidden: function (hidden) {
        $super.setHidden.call(this, hidden);
      },

      /**
       * Get previous topmenugroup located at same level that refMenu
       * @param {classes.TopMenuGroupWidget} refMenu - topmenugroup used as search criteria
       * @returns {classes.TopMenuGroupWidget} returns previous topmenugroup
       * @publicdoc
       */
      getPreviousMenu: function (refMenu) {
        return this.getChildren()[this.getIndexOfChild(refMenu) - 1];
      },

      /**
       * Get next topmenugroup located at same level that refMenu
       * @param {classes.TopMenuGroupWidget} refMenu - topmenugroup used as search criteria
       * @returns {classes.TopMenuGroupWidget} returns next topmenugroup
       * @publicdoc
       */
      getNextMenu: function (refMenu) {
        return this.getChildren()[this.getIndexOfChild(refMenu) + 1];
      },

      destroy: function () {
        $super.destroy.call(this);
      }
    };
  });
  cls.WidgetFactory.registerBuilder("TopMenu", cls.TopMenuWidget);
});
